import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Share = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        stroke={color}
        d="M7.14286 8.85714L2 6.28571L14 2L9.71429 14L7.14286 8.85714ZM7.14286 8.85714L10 6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Share
